import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "", city: "", industry: "", business: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      await register(form);
      toast.success("Welcome to WOWSHE.");
      nav("/dashboard");
    } catch (e2) {
      setErr(formatErr(e2.response?.data?.detail) || "Could not register.");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="register-page" className="section-pad container-luxe max-w-2xl">
      <p className="overline">Apply</p>
      <h1 className="font-display text-4xl text-aubergine mt-4">Join the room.</h1>
      <p className="mt-3 text-plumSoft font-light">Takes under a minute. We review applications within 5 working days.</p>

      <form onSubmit={submit} className="mt-10 card-luxe p-8 grid grid-cols-1 md:grid-cols-2 gap-5">
        <div className="md:col-span-2">
          <label className="label-luxe">Full name</label>
          <input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-luxe" />
        </div>
        <div>
          <label className="label-luxe">Email</label>
          <input data-testid="reg-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-luxe" />
        </div>
        <div>
          <label className="label-luxe">Phone</label>
          <input data-testid="reg-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="input-luxe" />
        </div>
        <div>
          <label className="label-luxe">Password</label>
          <input data-testid="reg-password" required type="password" minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-luxe" />
        </div>
        <div>
          <label className="label-luxe">City</label>
          <input data-testid="reg-city" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className="input-luxe" />
        </div>
        <div>
          <label className="label-luxe">Industry</label>
          <input data-testid="reg-industry" value={form.industry} onChange={(e) => setForm({ ...form, industry: e.target.value })} className="input-luxe" />
        </div>
        <div>
          <label className="label-luxe">Business / Role</label>
          <input data-testid="reg-business" value={form.business} onChange={(e) => setForm({ ...form, business: e.target.value })} className="input-luxe" />
        </div>
        {err && <p data-testid="reg-error" className="md:col-span-2 text-sm text-destructive">{err}</p>}
        <button data-testid="reg-submit" disabled={busy} className="btn-primary md:col-span-2 mt-2">{busy ? "Creating…" : "Create my account"}</button>
      </form>
      <p className="text-sm text-plumSoft mt-6 text-center font-light">
        Already a member? <Link to="/login" data-testid="reg-login-link" className="text-plum link-underline">Sign in</Link>
      </p>
    </div>
  );
}
